export const enumNiveauLangue = {
    LANGUEMATERNELLE : "Langue maternelle",
    COURANT : "Courant",
    AVANCE : "Avancé",
    INTERMEDIAIRE : "Intermédiaire",
    ELEMENTAIRE : "Élémentaire"
}